import { cn } from "../lib/cn";

const PULSE_RINGS = [
  { sizeClass: "h-32 w-32", borderClass: "border-teal-700/35", duration: "2.4s", delay: "0s" },
  { sizeClass: "h-32 w-32", borderClass: "border-teal-600/28", duration: "2.4s", delay: "0.6s" },
  { sizeClass: "h-32 w-32", borderClass: "border-teal-500/22", duration: "2.4s", delay: "1.2s" },
] as const;

/** The Heartbeat pulse: the orb on the quiet card, and the mark on anything Heartbeat delivers. */
export function PulseOrb({
  size = "default",
  onDark = false,
}: {
  size?: "default" | "inline";
  onDark?: boolean;
}) {
  const inline = size === "inline";
  const ringClass = onDark ? "border-paper/35" : "border-teal-700/40";
  const coreClass = onDark ? "bg-paper" : "bg-teal-700";
  return (
    <span
      aria-hidden="true"
      className={cn(
        "relative grid shrink-0 place-items-center",
        inline ? "h-10 w-10" : "h-36 w-36",
      )}
    >
      <span
        className={cn(
          "absolute rounded-full motion-safe:animate-[quiet-halo_2.4s_ease-in-out_infinite]",
          inline ? "h-14 w-14" : "h-48 w-48",
        )}
        style={{
          background: onDark
            ? "radial-gradient(circle, color-mix(in srgb, var(--color-paper) 28%, transparent) 0%, color-mix(in srgb, var(--color-paper) 10%, transparent) 42%, transparent 72%)"
            : "radial-gradient(circle, color-mix(in srgb, var(--color-teal-500) 32%, transparent) 0%, color-mix(in srgb, var(--color-teal-500) 12%, transparent) 42%, transparent 72%)",
        }}
      />
      <span
        className={cn("absolute rounded-full border", inline ? "h-7 w-7" : "h-14 w-14", ringClass)}
      />
      {inline ? (
        <span
          className={cn(
            "absolute h-10 w-10 rounded-full border",
            onDark ? "border-paper/25" : "border-teal-600/28",
          )}
          style={{
            animation: "quiet-orb-ring 2.4s cubic-bezier(0.33, 1, 0.68, 1) infinite",
          }}
        />
      ) : (
        PULSE_RINGS.map((ring) => (
          <span
            key={ring.delay}
            className={cn("absolute rounded-full border", ring.sizeClass, ring.borderClass)}
            style={{
              animation: `quiet-orb-ring ${ring.duration} cubic-bezier(0.33, 1, 0.68, 1) infinite`,
              animationDelay: ring.delay,
            }}
          />
        ))
      )}
      <span
        className={cn(
          "relative z-10 rounded-full motion-safe:animate-[quiet-core_2.4s_ease-in-out_infinite]",
          inline ? "h-2.5 w-2.5" : "h-7 w-7",
          coreClass,
        )}
        style={{
          boxShadow: onDark
            ? "0 0 0 6px color-mix(in srgb, var(--color-paper) 14%, transparent)"
            : "0 0 0 10px color-mix(in srgb, var(--color-teal-500) 12%, transparent)",
        }}
      />
    </span>
  );
}
